import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { FeatureConfigService } from '../services/feature-config.service';

/**
 * Blocks the `apex/rate-increases` route when the backend-controlled
 * `rate_increases_enabled` flag is off. When denied, redirects to the role
 * dashboard (derived from the attempted URL), mirroring AuthGuard's redirects.
 */
@Injectable({ providedIn: 'root' })
export class RateIncreasesFeatureGuard implements CanActivate {
  constructor(
    private featureConfig: FeatureConfigService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (await this.featureConfig.isRateIncreasesEnabled()) {
      return true;
    }
    const home = state.url.startsWith('/accounting') ? '/accounting' : '/admin';
    this.router.navigate([home]);
    return false;
  }
}
